import { WeatherCloudyClockIcon } from './WeatherCloudyClockIcon';

/**
 * author: Michael Irigoyen
 * id D7526077-1254-4F32-9496-3B8E5D957F0F
 * name weather-cloudy-clock
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/weather-cloudy-clock.svg
 * tags
 * - Weather 
 * - Cloud 
 */
export const WeatherDateIcon = WeatherCloudyClockIcon;
export default WeatherDateIcon